(function () {
  const STORAGE_KEY = 'pethome_cookie_consent';
  const COOKIE_NAME = 'pethome_cookie_consent';
  const COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

  function getBanner() {
    return document.querySelector('[data-cookie-consent]');
  }

  function getStoredConsent() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored === 'all' || stored === 'essential') return stored;
    } catch (e) {
      /* ignore */
    }

    const match = document.cookie.match(new RegExp('(?:^|; )' + COOKIE_NAME + '=([^;]*)'));
    if (!match) return null;
    const value = decodeURIComponent(match[1]);
    return value === 'all' || value === 'essential' ? value : null;
  }

  function persistConsent(value) {
    try {
      localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {
      /* ignore */
    }
    document.cookie =
      COOKIE_NAME +
      '=' +
      encodeURIComponent(value) +
      '; path=/; max-age=' +
      COOKIE_MAX_AGE +
      '; SameSite=Lax';
  }

  function syncShopifyConsent(acceptAll) {
    if (!window.Shopify || !window.Shopify.loadFeatures) return;

    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      function (error) {
        if (error || !window.Shopify.customerPrivacy) return;

        const consent = {
          analytics: acceptAll,
          marketing: acceptAll,
          preferences: acceptAll,
        };

        if (typeof window.Shopify.customerPrivacy.setTrackingConsent === 'function') {
          window.Shopify.customerPrivacy.setTrackingConsent(consent, function () {});
        }
      }
    );
  }

  function updateBannerOffset(banner) {
    if (!banner || !banner.classList.contains('is-visible')) return;
    document.documentElement.style.setProperty('--cookie-banner-offset', banner.offsetHeight + 'px');
  }

  function notifyConsentClosed() {
    document.dispatchEvent(new CustomEvent('pethome:cookie-consent-closed'));
  }

  function hideBanner(banner) {
    if (!banner) return;
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
    banner.hidden = true;
    document.body.classList.remove('cookie-consent--open');
    document.documentElement.style.removeProperty('--cookie-banner-offset');
    notifyConsentClosed();
  }

  function showBanner(banner) {
    if (!banner) return;
    banner.hidden = false;
    banner.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      banner.classList.add('is-visible');
      document.body.classList.add('cookie-consent--open');
      updateBannerOffset(banner);
    });
  }

  function applyConsent(value, banner) {
    persistConsent(value);
    syncShopifyConsent(value === 'all');
    hideBanner(banner);
  }

  function init() {
    const banner = getBanner();
    if (!banner) return;

    if (getStoredConsent()) {
      hideBanner(banner);
      return;
    }

    showBanner(banner);

    const acceptBtn = banner.querySelector('[data-cookie-accept]');
    const rejectBtn = banner.querySelector('[data-cookie-reject]');

    if (acceptBtn) {
      acceptBtn.addEventListener('click', function () {
        applyConsent('all', banner);
      });
    }

    if (rejectBtn) {
      rejectBtn.addEventListener('click', function () {
        applyConsent('essential', banner);
      });
    }

    window.addEventListener('resize', function () {
      updateBannerOffset(banner);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
